import React from "react";
// import my_logo from "../Images/my-logo-white.png";
import NavBar from "../../Components/Navbar";
import { Link } from "react-router-dom";
// import hcb from "../Images/thewharf.jpeg";
// import hcb1 from "../Images/53edit1.jpeg";
import prof from "../../Images/ayg-icon.jpg";
import SimilarYacht from "../../Components/SimilarYacht";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";

const NewsDetails9 = () => {
  return (
    <div>
      <NavBar />
      <Helmet>
        <title>Miami International Boat Show!</title>

        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Fort Lauderdale International Boat Show | FLIBS "
        />

        <meta
          property="og:site_name"
          content="Americanyachtgroupinternational"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <div
        style={{
          background:
            "radial-gradient(ellipse at 50% -50%, #6c94ff 0, #000 100%)",
          height: "100px",
        }}
      ></div>
      <section className="news-details mt-5 mb-2">
        <div className="container p-5 bg-body-tertiary">
          <div className="row mb-5">
            <div className="col-12 col-md-6 d-flex align-items-center text-primary-emphasis">
              <div>
                <p className="mb-1 fw-bold">Feb 12 - 16, 2025</p>
                <h2 className="fw-bold text-uppercase">
                  Miami International Boat Show!
                </h2>

                <p className="mb-2">
                  <i className="fa-solid fa-pen-nib" /> Hunter Lajiness
                </p>
                {/* <Link
                  to="..."
                  variant=""
                  className="btn gradient-c1 text-white"
                >
                  BOOK NBS APPOINTMENT<i class="fa-solid fa-angles-right"></i>
                </Link> */}
                {/* <p>
                  For more details contact us at{" "}
                  <span className="fw-bold">VIP@hcbyachts.com</span> or visit
                  our store front in Bayfront, Naples!
                </p> */}
              </div>
            </div>
            <div className="col-12 col-md-6">
              <img
                src="https://ayg.s3.us-east-2.amazonaws.com/MIBS_1+(1).png"
                alt="..."
                className="img-fluid mt-3"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12 col-md-12 ">
              <p
                style={{ textAlign: "justify" }}
                className="text-primary-emphasis fw-bold"
              >
                “Miami, It’s Time to Make Waves! Discover Boating’s 2025 Boat
                Show!” We're excited to kick off one of the largest in-water
                international boat shows of the year—Discover Boating’s Miami
                International Boat Show!
              </p>
              <h6 className="text-primary-emphasis">
                HCB is bringing the latest and greatest in center consoles and
                cutting-edge technology to the show. Nearly a year after the
                groundbreaking debut of the 48' Campeón, which earned the NMMA
                Innovation Award, we’re back with even more to showcase.
              </h6>
            </div>
          </div>

          <p
            style={{ textAlign: "justify" }}
            className="text-primary-emphasis"
          ></p>
          <div className="row mb-5">
            <div className="col-12 col-md-6">
              <img
                src="https://ayg.s3.us-east-2.amazonaws.com/MIBS_2.jpg"
                alt="..."
                className="img-fluid mt-3"
              />
            </div>
            <div className="col-12 col-md-6 d-flex align-items-center">
              <div>
                <p
                  style={{ textAlign: "justify" }}
                  className="text-primary-emphasis"
                >
                  Get ready to experience our full lineup of 2025 model center
                  console yachts, along with the latest innovation from HCB—the
                  all new 56' Sueños GIX.
                </p>
                <p
                  style={{ textAlign: "justify" }}
                  className="text-primary-emphasis pt-2"
                >
                  At the Fort Lauderdale Boat Show, we had an incredible turnout
                  and a highly successful launch of the 56' Sueños GIX!
                </p>
                <p
                  style={{ textAlign: "justify" }}
                  className="text-primary-emphasis pt-2"
                >
                  If you missed your chance in Fort Lauderdale, now’s your
                  opportunity to see this breathtaking 56' firsthand at the
                  Miami International Boat Show.
                </p>
              </div>
            </div>

            <p
              style={{ textAlign: "justify" }}
              className="text-primary-emphasis pt-3"
            >
              Stop by our booth, climb aboard our world class center console
              yachts, and experience the next level of luxury and innovation.
              See you there!
            </p>
            <p
              style={{ textAlign: "justify" }}
              className="text-primary-emphasis"
            >
              We look forward to seeing you there!
            </p>
          </div>
        </div>
      </section>
      {/*Similar Yachts For Sale */}
      <section className="mb-4">
        <Container fluid className="col-lg-11">
          <h4 className="fw-bold text-primary-emphasis">
            Other HCB Yachts For Sale
          </h4>
          <hr />
          <SimilarYacht />
        </Container>
      </section>
    </div>
  );
};

export default NewsDetails9;
